import { useNewCode } from '@calendly/feature-check-react';
import { I18n } from '@calendly/i18n';
import { CalendlyCallie } from '@calendly/ui/components/glyphs/CalendlyCallie';
import { IconSettings } from '@calendly/ui/components/glyphs/IconSettings';
import { IconSparkles2 } from '@calendly/ui/components/glyphs/IconSparkles2';
import { Link } from '@calendly/ui/components/link';
import { BodyText, LabelText, TitleText } from '@calendly/ui/components/typography';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { useViewportSize } from '@calendly/ui/hooks/viewport-size-context';
import { gradientAiIcon, gradientIconAI } from '@calendly/ui/theme';
import { CallieHeaderDecorations } from './header_decorations';
const headerCss = "h1gx06t5";
const headerTopCss = "h3zlo62";
const headerCopyCss = "h9dbpma";
const headerTextCss = "h1a96a0q";
export const CallieHeader = () => {
  const {
    isSmallViewport
  } = useViewportSize();
  const isCompanyLogoEnabled = useNewCode('ap_product_refresh_2026_company_logo')?.enabled;
  const settingsLink = <Link href="/app/personal/assistant" standalone>
      <UiIcon icon={IconSettings} size="medium" />
      <LabelText size="large">
        {I18n.t('publisher.home.scheduling_subsection.callie.card.settings_link')}
      </LabelText>
    </Link>;
  return <header className={headerCss}>
      <CallieHeaderDecorations />
      <div className={headerTopCss}>
        <div className={headerCopyCss}>
          <UiIcon color={isCompanyLogoEnabled ? gradientIconAI : gradientAiIcon} icon={isCompanyLogoEnabled ? CalendlyCallie : IconSparkles2} size="medium" />
          <div className={headerTextCss}>
            <TitleText level="2" size="medium">
              {I18n.t('publisher.home.scheduling_subsection.callie.card.title')}
            </TitleText>
            <BodyText color="muted" size="medium" weight="semibold">
              {I18n.t('publisher.home.scheduling_subsection.callie.card.subtitle')}
            </BodyText>
            {isSmallViewport && settingsLink}
          </div>
        </div>
        {!isSmallViewport && settingsLink}
      </div>
    </header>;
};

require("./header.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./header.js");